module.exports = __webpack_public_path__ + "img/kepi-logo.ce5259f1.png";